(function () {
    'use strict';
    $(document).ready(function () {
        const $header = $('header');

        $(".menu-toggle").on('click', function () {
            $('.menu-overlay')
                .toggleClass('open')
                .slideToggle(300);

            $(this).toggleClass("open");
            $header.toggleClass('open');
        });

        $(window).resize(function () {
            $header.removeClass('open');
            $('.menu-toggle').removeClass('open');
            $('.menu-overlay.open').slideUp(function () {
                $(this).css('display', '');
            });
        });
    });
}(jQuery));
